import React from 'react'
import "./home.css"
import Data from './Data.jsx'
import scrollIcon from "../assets/scroll.svg"
import { motion, useInView, useAnimation } from "framer-motion"
import { useState } from 'react'
import mainImage from '../assets/mainPicture.jpg'


const Home = () => {

  return (
    <section className="home section" id="home">
      <img className='home__img' src={mainImage} alt="" />
      <motion.div className="home__container container">
          <div className="home__content">
              
              <Data />

          </div>
          
      </motion.div>
      <div className='home__scroll' >
        <motion.div
          initial={{
            y: -20,
            opacity: 0
          }}
          animate={{
            y:0,
            opacity: 1
          }}
          transition={{
            duration: 1,
            delay: 3
          }}
          viewport={{
            once: true,
          }}
        >
           <div className='home__button__container'>
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                duration: 1,
                delay: 1.5
              }}
              viewport={{
                once: true,
              }}
              >
                <a href="https://redefinemd.janeapp.com/#/staff_member/8" target='blank' className="button button--flex home__button">
                  Book an Appointment&nbsp;&nbsp;
                </a>
              </motion.div>
            </div>
          <br />
          <img src={scrollIcon} alt=''/>
        </motion.div>
      
      </div>
    </section>
  )
}

export default Home
